export const LIMIT = 10;
export const UPLOAD_CONST = "";
export const LOGO = process.env.REACT_APP_LOGO;
export const BANNER = process.env.REACT_APP_BANNER;

export const URI = process.env.REACT_APP_URI;
